export function nativeBackDestination(pathname: string, search: string, state: unknown): string | null {
  if (pathname === '/app/dashboard') {
    const tab = new URLSearchParams(search).get('tab');
    if (!tab || tab === 'passports') return null;
    const previous = state && typeof state === 'object' && 'previousDashboardTab' in state
      ? (state as { previousDashboardTab?: unknown }).previousDashboardTab : null;
    const returnTab = previous === 'flights' || previous === 'world' || previous === 'more' ? previous : 'passports';
    return `/app/dashboard?tab=${returnTab}`;
  }
  if (pathname === '/app/new-trip') return new URLSearchParams(search).get('mode') === 'agency_review' ? '/app/new-trip' : '/app/dashboard?tab=passports';
  if (pathname.startsWith('/app/passport/shared/')) return '/';
  if (pathname.startsWith('/app/passport/')) return '/app/dashboard?tab=passports';
  if (pathname === '/app/discover') return '/app/dashboard';
  if (pathname === '/app/travel-desk') return '/app/dashboard';
  if (pathname === '/app/login') return '/';
  if (pathname.startsWith('/flights/follow/')) return '/app/dashboard?tab=flights';
  if (pathname.startsWith('/passport/shared/')) return '/';
  if (pathname.startsWith('/passport/')) return '/app/dashboard?tab=passports';
  if (pathname === '/resultado') return '/';
  return null;
}

export function isBackSwipe(startX: number, startY: number, endX: number, endY: number): boolean {
  const dx = endX - startX;
  const dy = Math.abs(endY - startY);
  return startX <= 28 && dx >= 80 && dy < dx * 0.6;
}
